/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectInvitationData
 */
export interface CrmProjectInvitationData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectInvitationData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectInvitationData
     */
    roleName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectInvitationData
     */
    isOwner?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectInvitationData
     */
    createdAt?: Date | null;
}

/**
 * Check if a given object implements the CrmProjectInvitationData interface.
 */
export function instanceOfCrmProjectInvitationData(value: object): value is CrmProjectInvitationData {
    return true;
}

export function CrmProjectInvitationDataFromJSON(json: any): CrmProjectInvitationData {
    return CrmProjectInvitationDataFromJSONTyped(json, false);
}

export function CrmProjectInvitationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectInvitationData {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'roleName': json['roleName'] === undefined ? undefined : json['roleName'] === null ? null : json['roleName'],
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
        'createdAt': json['createdAt'] === undefined ? undefined : json['createdAt'] === null ? null : (new Date(json['createdAt'])),
    };
}

export function CrmProjectInvitationDataToJSON(json: any): CrmProjectInvitationData {
    return CrmProjectInvitationDataToJSONTyped(json, false);
}

export function CrmProjectInvitationDataToJSONTyped(value?: CrmProjectInvitationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'roleName': value['roleName'],
        'isOwner': value['isOwner'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

